import { render, staticRenderFns } from "./PayerForm.vue?vue&type=template&id=16dc5bee&scoped=true"
import script from "./PayerForm.vue?vue&type=script&lang=js"
export * from "./PayerForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16dc5bee",
  null
  
)

export default component.exports